import { defineComponent, computed } from "vue";
import { storeToRefs } from "pinia";
import { useMaintenanceScheduleStore } from "../maintenanceScheduleStore";
export default defineComponent({
    name: "MaintenanceScheduleMileage",
    setup() {
        const store = useMaintenanceScheduleStore();
        const { questionTrimAnswer, questionMileageAnswer } = storeToRefs(store);
        const showMileageQuestion = computed(() => questionTrimAnswer.value !== undefined);
        const mileageIsInvalid = computed(() => questionMileageAnswer.value < 0 &&
            questionMileageAnswer.value != undefined);
        const fieldIsDisabled = computed(() => questionTrimAnswer.value === undefined);
        function getMaintenanceSchedule(event) {
            if (fieldIsDisabled.value) {
                event.preventDefault();
                return;
            }
            if (questionMileageAnswer.value != undefined &&
                questionMileageAnswer.value >= 0) {
                store.getMaintenanceSchedule();
            }
        }
        store.$subscribe((mutation, state) => {
            if (state.questionMileageAnswer === undefined) {
                store.clearMaintenanceSchedule();
            }
        });
        return {
            questionMileageAnswer,
            getMaintenanceSchedule,
            mileageIsInvalid,
            fieldIsDisabled,
            showMileageQuestion,
        };
    },
});
